export default __webpack_public_path__ + "static/media/pizzaday-tile.8c1d00c0.png";